import { Component, AfterViewInit, Renderer2, ViewChildren, QueryList, ElementRef, ViewChild, HostListener } from '@angular/core';
import { ScrollSpyService } from './scrollspy.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  listOfElements = [];
  listOfElementsForBot = [];

  @ViewChildren('nav') navs: QueryList<ElementRef>;
  @ViewChildren('element') elements: QueryList<ElementRef>;
  @ViewChildren('botnav') botnavs: QueryList<ElementRef>;
  @ViewChild('header', {static: true}) header: ElementRef;


  constructor(private scrollSpyService: ScrollSpyService, _renderer: Renderer2) {
    scrollSpyService._renderer = _renderer;
  }

  ngAfterViewInit() { 

    this.listOfElements = this.scrollSpyService.getListOfElements(this.navs, this.elements);
    this.scrollSpyService.startScrollSpy(this.listOfElements, this.header);
    this.listOfElementsForBot = this.scrollSpyService.getListOfElements(this.botnavs, this.elements);
    this.onBotnavClick();

  }

  @HostListener('window:resize', [])
  onResize() {
    this.listOfElements = this.scrollSpyService.getListOfElements(this.navs, this.elements);
    this.scrollSpyService.onResize(this.listOfElements);
  }

  onBotnavClick() {
    this.listOfElementsForBot.forEach(el => {
      el.navigation.addEventListener('click', () => window.scrollTo(0, (el.top - 42)));
    })
  }
}
